import axios, { AxiosResponse, AxiosRequestConfig } from "axios";
import config from "../config";
import {
  POST_FORGET_PASSWORD,
  POST_JWT_LOGIN,
  POST_REGISTER,
} from "./url_helper";
import qs from "qs";
const { api } = config;

// default
axios.defaults.baseURL = api.API_URL;
// content type
axios.defaults.headers.post["Content-Type"] = "application/json";

// content type
const authUser: any = localStorage.getItem("authUser");
const token = JSON.parse(authUser) ? JSON.parse(authUser).token : null;
if (token) axios.defaults.headers.common["Authorization"] = "Bearer " + token;

axios.interceptors.request.use(
  (config) => {
    if (
      config.url === POST_JWT_LOGIN ||
      config.url === POST_FORGET_PASSWORD ||
      config.url === POST_REGISTER
    ) {
      config.headers.Authorization = null;
      return config;
    }

    let token = "";
    try {
      token = JSON.parse(localStorage.getItem("authUser") || "")
        ? JSON.parse(localStorage.getItem("authUser") || "").token
        : "";
    } catch (e) {
      // console.log("error", e);
    }

    config.headers.Authorization = `Bearer ${token}`;

    return config;
  },
  (error) => {
    // Handle request errors here
    return Promise.reject(error);
  }
);

// intercepting to capture errors
axios.interceptors.response.use(
  function (response) {
    return response?.data ? response?.data : response;
  },
  function (error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger

    let message;

    switch (error?.response?.status) {
      case 500:
        message = "Internal Server Error";
        break;
      case 401:
        // console.log("Error response 401", error.response);
        message = "Invalid credentials";
        if (error.response.statusText === "Unauthorized") {
          message = "Session Expired. Please login again";
          localStorage.removeItem("authUser");
          // Get the current pathname
          const currentPath = window.location.pathname;

          // Extract the dynamic part ('some' in this case)
          const segments = currentPath.split("/"); // Split the path into parts
          const dynamicPart = segments[1]; // Assuming 'some' is always the second part

          // Replace the dynamic part and construct the new URL
          const newPath = `/${dynamicPart}/login`;

          // Navigate to the new URL
          window.location.href = `${window.location.origin}${newPath}`;
        }
        break;
      case 404:
        message = "Sorry! the data you are looking for could not be found";
        break;
      case 403:
        message = "You do not have permissions to access this resource";
        break;
      default:
        message = error.message || error;
    }
    return Promise.reject(error);
  }
);
/**
 * Sets the default authorization
 * @param {*} token
 */
const setAuthorization = (token: string) => {
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
};

class APIClient {
  /**
   * Fetches data from the given URL
   */
  get = (url: string, params?: any, headers?: any): Promise<AxiosResponse> => {
    let response: Promise<AxiosResponse>;

    if (params) {
      //   Object.keys(params).map((key) => {
      //     paramKeys.push(key + "=" + params[key]);
      //     return paramKeys;
      //   });

      //   const queryString =
      //     paramKeys && paramKeys.length ? paramKeys.join("&") : "";
      const queryString = qs.stringify(params);

      response = axios.get(`${url}?${queryString}`, headers);
    } else {
      response = axios.get(`${url}`, headers);
    }

    return response;
  };

  /**
   * Posts the given data to the URL
   */
  create = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.post(url, data);
  };

  createAndUpload = (url: string, data: any): Promise<AxiosResponse> => {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axios.post(url, data, config);
  };

  /**
   * Updates data
   */
  update = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.put(url, data);
  };

  updateAndUpload = (url: string, data: any): Promise<AxiosResponse> => {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return axios.put(url, data, config);
  };

  put = (url: string, data: any): Promise<AxiosResponse> => {
    return axios.put(url, data);
  };

  /**
   * Deletes data
   */
  delete = (
    url: string,
    config?: AxiosRequestConfig
  ): Promise<AxiosResponse> => {
    return axios.delete(url, { ...config });
  };
}

const getLoggedinUser = () => {
  const user = localStorage.getItem("authUser");
  if (!user) {
    return null;
  } else {
    return JSON.parse(user);
  }
};

export { APIClient, setAuthorization, getLoggedinUser };
